import { GlassCard } from "@/components/ui/glass-card";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Settings2, Shield } from "lucide-react";
import ComingSoon from "@/components/ComingSoon";

interface DeviceConfigurationsProps {
  deviceId: string;
}

const DeviceConfigurations = ({ deviceId }: DeviceConfigurationsProps) => {
  // No backend API for device configurations/privilege rules yet
  return (
    <GlassCard variant="default" hover={false} className="p-6">
      <h2 className="text-xl font-semibold mb-4 text-foreground">Device Configurations</h2>
      <div className="text-center py-12 text-muted-foreground">
        <Settings2 className="h-12 w-12 mx-auto mb-3 text-muted-foreground/50" />
        <p className="text-lg font-medium mb-2">Coming Soon</p>
        <p className="text-sm">Device configuration management requires backend Scripts/Configurations APIs.</p>
      </div>
    </GlassCard>
  );
};

export default DeviceConfigurations;
